import { createReducer } from './utils';
import {
  REPORT_SUCCESS,
  REPORT_FAILURE,
  REPORT_LOADING,
} from './constants';
import { dispatchSnack } from './utils/snackbar';

const HTTP_STATUS_CONFLICT = 409;

const defaultState = {
  errorMessage: null,
  //tasks report:
  reportMessage: '',
  loadingReport: false,
};

// reducer

export const reducer = createReducer(defaultState, {
  [REPORT_SUCCESS]: handleReportSuccess,
  [REPORT_FAILURE]: handleReportFailure,
  [REPORT_LOADING]: handleReportLoading,
});

//tasks report
function handleReportLoading(state, action) {
  return {
    ...state,
    loadingReport: true,
  };
}

function handleReportSuccess(state, { payload: { message } }) {
  return {
    ...state,
    loadingReport: false,
    reportMessage: message,
  };
}

function handleReportFailure(state, { payload: { error } }) {
  return {
    ...state,
    loadingReport: false,
    reportMessage: error,
  };
}

// actions

// TODO: unify createTasks and reportProduct into a single action.
// Mobile uses createTasks via setReportParameters (state-based).
// Web uses reportProduct with explicit params. Refactor mobile to use reportProduct.
export function createTasks() {
  return async (dispatch, getState, { services: { dataSource, colors } }) => {
    dispatch({ type: REPORT_LOADING });
    const {
      stores: { currentStore },
      search: { reportParameters },
    } = getState();

    try {
      let parameters = Object.assign({}, reportParameters);
      if (parameters['aisle'] === '') {
        delete parameters['aisle'];
      }
      parameters['store'] = currentStore;

      const response = await dataSource.requestCreateTasks({ parameters });
      const message = response['message'];

      dispatch({ type: REPORT_SUCCESS, payload: { message } });
      dispatchSnack(dispatch, 'bruno.scanner.task_created', colors.getSuccessColor());
      return { success: true };
    } catch (error) {
      dispatch({ type: REPORT_FAILURE, payload: { error } });
      dispatchSnack(dispatch, 'bruno.scanner.task_error', colors.getErrorColor());
      return { success: false };
    }
  };
}

export function reportProduct({ item, ean, taskType, realStock }) {
  return async (dispatch, getState, { services: { dataSource, colors } }) => {
    const { stores: { currentStore } } = getState();
    try {
      const parameters = { store: currentStore, item, ean, task_type: taskType };
      if (realStock !== undefined && realStock !== '') {
        parameters.real_stock = parseFloat(realStock);
      }
      await dataSource.requestCreateTasks({ parameters });
      dispatchSnack(dispatch, 'bruno.products.reportMessageSuccess', colors.getSuccessColor());
      return { success: true };
    } catch (error) {
      dispatchSnack(dispatch, 'bruno.products.report_error', colors.getErrorColor());
      return { success: false };
    }
  };
}

// staleTask is true when the task was created again after the list was read,
// so the list must be read again before a retry.
export function updateTasks(task_id, task_type, status, real_stock, creation_timestamp) {
  return async (dispatch, getState, { services: { dataSource, colors } }) => {
    const {
      stores: { currentStore },
    } = getState();

    try {
      const response = await dataSource.requestUpdateTasks({
        store: currentStore,
        task_id: task_id,
        task_type: task_type,
        status: status,
        real_stock: real_stock,
        creation_timestamp: creation_timestamp,
      });
      // http.makeRequest resolves an error response that has a message, and
      // only that response carries a status.
      if (response?.status) {
        console.error('updateTasks: the API refused the update with status', response.status);
        dispatchSnack(dispatch, 'bruno.tasks.update_error', colors.getErrorColor());
        return { success: false, staleTask: response.status === HTTP_STATUS_CONFLICT };
      }
      dispatchSnack(dispatch, 'bruno.tasks.update_success', colors.getSuccessColor());
      return { success: true };
    } catch (error) {
      dispatchSnack(dispatch, 'bruno.tasks.update_error', colors.getErrorColor());
      console.log('updateTasks error', error);
      return { success: false };
    }
  };
}
